export const MAX_FILE_SIZE_MB = 100;
export const BYTES_PER_MB = 1024 * 1024;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * BYTES_PER_MB;

export const isFileSizeOverLimit = (totalBytes) => totalBytes > MAX_FILE_SIZE_BYTES;
